
import { defineComponent } from 'vue'
import BuildingImage from '@/components/BuildingImage.vue'
import { useSession } from '@/composables/auth'

export default defineComponent({
  props: ['mybuilding'],
  setup() {
    let { user } = useSession()
    return {
      user
    }
  },
  data() {
    return {
      building: this.mybuilding
    }
  },
  computed: {
    userFullName(): string {
      return this.user.first_name + ' ' + this.user.last_name
    },
    creationDate(): string {
      if (this.mybuilding.creation_date) {
        const date = new Date(this.mybuilding.creation_date)
        const d = date.toLocaleString()
        return d
      } else return ''
    },
    lastUpdateDate(): string {
      if (this.mybuilding.last_update) {
        const date = new Date(this.mybuilding.last_update)
        const d = date.toLocaleString()
        return d
      } else return ''
    }
  },
  methods: {
    getFormattedAdress() {
      if (this.mybuilding.address) {
        let myadress = this.mybuilding.address
        return myadress.formatted_address
      }
    }
  },
  components: { BuildingImage }
})
